import React, { Fragment, useEffect } from 'react';
import { Button, Dropzone, FileList, Card, Heading, Icon, InlineMessage } from '@innovaccer/design-system';

import { readFileData } from '../../../utils/file';
import classes from './styles.module.css';

function ConfigUpload(props) {
  const [files, setFiles] = React.useState([]);
  const [showError, setShowError] = React.useState(false);

  useEffect(() => {
    if (!_.isEmpty(props.executionConfig)) {
      const file = new File([props.executionConfig], 'execution-config.json', {
        type: 'application/json'
      });
      props.executionConfig &&
        setFiles([
          {
            file,
            id: files.length,
            fileSize: getSize(file.size),
            networkError: false,
            type: 'others'
          }
        ]);
    }
  }, [props.executionConfig]);

  const getSize = (size) => `${(size / (1024 * 1024)).toFixed(2)} MB`;

  const downloadConfigFile = () => {
    const blob = new Blob([JSON.stringify(props.executionConfig, null, 6)], { type: 'application/json' });
    const href = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = href;
    link.download = files[0].file.name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const onDelete = () => {
    setFiles([]);
    props.handleConfigUpload({});
  };

  const onDropHandler = (event, acceptedFiles, rejectedFiles) => {
    let jsonData;
    const acceptedFileDetailList = acceptedFiles.map((file, id) => ({
      file,
      id: files.length + id,
      fileSize: getSize(file.size),
      networkError: false
    }));

    const rejectedFilesDetailList = rejectedFiles.map((rejectedFile, id) => {
      const { file, errors } = rejectedFile;
      const errorMessageArray = errors.map((error) => error.message);
      return {
        file,
        id: files.length + id,
        fileSize: getSize(file.size),
        status: 'error',
        errorMessage: errorMessageArray.join(' and '),
        networkError: false
      };
    });
    const updatedFiles = [...files, ...acceptedFileDetailList, ...rejectedFilesDetailList];
    setFiles(updatedFiles);
    updatedFiles.forEach(async (item) => {
      jsonData = await readFileData(item.file);
      try {
        const data = JSON.parse(jsonData);
        props.handleConfigUpload(data);
      } catch (err) {
        setShowError(true);
      }
    });
  };

  const actionRenderer = (fileItem) => {
    return (
      <React.Fragment>
        {fileItem.networkError && (
          <Button
            aria-label={`Remove ${fileItem.file.name}`}
            appearance="transparent"
            icon="refresh"
            size="regular"
            onClick={() => onDelete(fileItem.id)}
            className={'cursor-pointer'}
          />
        )}
        <Button
          aria-label={`Download ${fileItem.file.name}`}
          appearance="transparent"
          icon="download"
          size="regular"
          onClick={() => downloadConfigFile()}
          className={'cursor-pointer'}
        />
        <Button
          aria-label={`Remove ${fileItem.file.name}`}
          appearance="transparent"
          icon="close"
          size="regular"
          onClick={() => onDelete(fileItem)}
          className={'cursor-pointer'}
        />
      </React.Fragment>
    );
  };

  return (
    <div className="p-3">
      <Heading size="s" className="ml-6">
        {files.length == 0 ? 'Upload config' : 'Uploaded file'}
      </Heading>
      {files.length == 0 && (
        <Fragment>
          <Dropzone
            accept="application/json"
            formatLabel="Accepted formats: json"
            multiple={false}
            onDrop={onDropHandler}
            maxSize={26214400}
            className="my-6"
          />
          <div className="d-flex mt-4">
            {!showError ? (
              <InlineMessage
                appearance="info"
                description="Please upload json file for execution settings and placeholder modifications."
              />
            ) : (
              <InlineMessage appearance="info" description="Please upload valid json file" />
            )}
          </div>
        </Fragment>
      )}
      {files.length > 0 && (
        <FileList className={`${classes.StandardETLFileIcon} m-6`} fileList={files} actionRenderer={actionRenderer} />
      )}
    </div>
  );
}

export default ConfigUpload;
